import { React, useState, useEffect } from "react";
import { BASE_URL } from "../env";
import style from "../Assets/css/adminSlider.module.css";
import { store } from "react-notifications-component";

const ImgSlider = () => {
	const [imgUrl, setImgUrl] = useState("");
	const [linkUrl, setLink] = useState("");
	const [courses, setCourses] = useState([]);
	const [course, setcourse] = useState("");

	useEffect(() => {
		fetch(BASE_URL + "/getallCourse")
			.then((res) => res.json())
			.then((data) => {
				setCourses(data?.courses);
				console.log(data?.courses);
			});
	}, []);

	const uploadImage = async (e) => {
		const notifyPopup = () => {
			store.addNotification({
				title: "Success!",
				message: "Form Submitted Successfully!",
				type: "success",
				background: "pink",
				insert: "bottom",
				container: "bottom-right",
				animationIn: ["animate__animated", "animate__fadeIn"],
				animationOut: ["animate__animated", "animate__fadeOut"],
				dismiss: {
					duration: 3000,
					onScreen: true,
				},
			});
		};
		const data = {
			imgURL: imgUrl,
			linkUrl: linkUrl,
			courseName: course,
		};

		await fetch(BASE_URL + "/uploadimgdata", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(data),
		})
			.then((res) => res.json())
			.then((data) => {
				notifyPopup();
				console.log(data);
			});
	};

	return (
		<div className={style.adminSliderPage}>
			<div className={style.adminSliderCard}>
				<div className={style.adminSliderCardHeading}>Upload Image</div>
				<form className={style.adminSliderform} onSubmit={uploadImage}>
					<input
						type="text"
						className={`form-control ${style.adminSliderCardField}`}
						placeholder="Enter The Image Url"
						value={imgUrl}
						onChange={(e) => {
							setImgUrl(e.target.value);
							console.log(imgUrl);
						}}
					/>

					<input
						type="text"
						className={`form-control ${style.adminSliderCardField}`}
						placeholder="Enter The Link"
						value={linkUrl}
						onChange={(e) => {
							setLink(e.target.value);
							console.log(linkUrl);
						}}
					/>

					<select
						className={`form-control ${style.adminSliderCardField}`}
						aria-label="Default select example"
						video=""
						id=""
						value={course}
						onChange={(e) => {
							setcourse(e.target.value);
							console.log(course);
						}}
					>
						<option value="">Select Course</option>
						{courses.map((val) => {
							return (
								<option value={val?._name}>{val?.name}</option>
							);
						})}
					</select>
					<button
						type="submit"
						className={`btn ${style.adminSliderFormBtn}`}
					>
						Submit
					</button>
				</form>
			</div>
		</div>
	);
};

export default ImgSlider;
